/**
 * Article comparison: same prompt at temperature 0.2 vs. 0.9 (“What is a deity from Greek mythology?”).
 */
export const GREEK_DEITY_TEMP_02_GENERATIONS: string[] = [
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a prominent deity from Greek mythology.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a prominent deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a prominent deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a prominent deity from Greek mythology, known as the king of the gods.',
  'Zeus is a prominent deity from Greek mythology.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a prominent deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a prominent deity from Greek mythology, known as the king of the gods.',
  'Zeus is a prominent deity in Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a prominent deity in Greek mythology, known as the king of the gods.',
  'Zeus is a prominent deity in Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a prominent deity from Greek mythology, known as the king of the gods.',
];

export const GREEK_DEITY_TEMP_09_GENERATIONS: string[] = [
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a prominent deity in Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a well-known deity from Greek mythology, often regarded as the king of the gods.',
  'Zeus is a prominent deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology.',
  'Zeus is a deity from Greek mythology.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a prominent deity in Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology.',
  'Zeus is a major deity from Greek mythology, known as the king of the gods.',
  'Zeus is a prominent deity from Greek mythology.',
  'Zeus is a deity from Greek mythology.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a prominent deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus, the king of the gods and ruler of Mount Olympus, is a deity from Greek mythology.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'A deity from Greek mythology is Zeus, the king of the gods.',
  'Zeus is a deity from Greek mythology.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a prominent deity in Greek mythology, known as the king of the gods.',
  'Zeus, the king of the gods and ruler of Mount Olympus, is a prominent deity in Greek mythology.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a prominent deity from Greek mythology, known as the king of the gods.',
  'Zeus is a well-known deity from Greek mythology.',
  'Zeus is a prominent deity from Greek mythology, known as the king of the gods.',
  'Zeus is a major deity from Greek mythology, known as the king of the gods.',
  'Zeus is a prominent deity in Greek mythology, known as the king of the gods.',
  'Zeus is a prominent deity from Greek mythology, known as the king of the gods.',
  'Zeus is a prominent deity in Greek mythology.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a major deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'Zeus is a prominent deity from Greek mythology, known as the king of the gods.',
  'Zeus is a prominent deity from Greek mythology, known as the king of the gods.',
  'Zeus is a deity from Greek mythology, known as the king of the gods.',
  'A deity from Greek mythology is Zeus, the king of the gods.',
  'Zeus is a deity from Greek mythology.',
];
